import React from 'react';
import image404 from "../assets/images/notfount.png";

const PageNotFound = () => {
    return (
        <div className="container mx-auto mt-32 flex flex-col justify-center items-center">
            <img src={image404} alt="404 Page Not Found" className='max-h-80'/>
            <span className='font-bold text-4xl mb-10 text-primary'>
                Page Not Found
            </span>
        </div>
    );
};

export default PageNotFound;
